import * as yup from "yup";

export const createSchema = yup.object().shape({
  promo_name: yup.string().required(),
  start_date: yup.date().required(),
  end_date: yup.date().required(),
  discount: yup.number().required(),
});
